import { z } from "zod";
import { emailValidation } from "../../../validation/user";

export const NewsletterRegisterPostBodySchema = z.object({
  email: emailValidation,
});

// Use z.infer to create a type that matches the Zod schema
export type NewsletterRegisterPostBody = z.infer<typeof NewsletterRegisterPostBodySchema>;
